import React from "react";
import { Zap } from "lucide-react";
import ServicePage from "./ServicePage";
import hydroseeding from "../../assets/images/jpg/hydroseeding.jpg";

const service = {
  title: "Hydroseeding",
  icon: Zap,
  image: hydroseeding,
  description:
    "Efficient hydroseeding solutions for establishing fresh, even, and healthy lawn coverage across larger outdoor areas.",
  longText:
    "Hydroseeding is a practical way to seed lawns, banks, and open ground with a consistent mix of seed, mulch, water, and nutrients. Our team prepares the area carefully and applies the right blend for strong germination and long-term lawn health.",
  points: [
    "New lawn establishment",
    "Large area seed application",
    "Erosion control support",
    "Even seed and mulch coverage",
    "Soil preparation guidance",
    "Cost-effective lawn creation",
  ],
};

export default function Hydroseeding() {
  return <ServicePage service={service} />;
}
